import { useEffect, useState } from 'react';

export default function useAuth() {
  const [isLogged, setIsLogged] = useState(false);
  const sessionToken = localStorage.getItem('session-token');
  useEffect(() => {
    if (sessionToken) {
      setIsLogged(true);
    }
  }, [sessionToken]);
  return {
    isLogged,
  };
}
